
import { defineComponent } from '@nuxtjs/composition-api'
import { useLocationStore } from '~/store/location'

export default defineComponent({
  name: 'Delivery',
  asyncData({ redirect, $pinia }) {
    const locationStore = useLocationStore($pinia)
    let url = '/about/delivery/other/'
    if (locationStore.isDagestan)
      url = '/about/delivery/dagestan/'
    else if (locationStore.currentCity?.name === 'Москва')
      url = '/about/delivery/moscow/'

    redirect(url)
  },
})
